/**
 * PlanSummary — Zusammenfassungs-/Hero-Box über den Tageskarten.
 *
 * Zeigt „Ich möchte fahren: N Fahrten" plus eine Unterzeile mit den Zählern
 * Könnte / Kann nicht / Noch offen. Die Zähler werden über alle 5 Tage ×
 * {Vormittag, Nachmittag} aus der Sicht der angezeigten Person berechnet.
 * Im „Bearbeiten für"-Modus wechselt der Hintergrund auf secondary.
 */

import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import { useI18n } from "../../i18n/I18nProvider";
import { statusOf } from "./helpers";
import type { DayView } from "./types";

export default function PlanSummary({
  days,
  displayedUserId,
  editingForName,
}: {
  days: DayView[];
  displayedUserId: string | undefined;
  /** Gesetzt → Überschrift personalisiert + secondary-Hintergrund. */
  editingForName: string | null;
}) {
  const { t } = useI18n();

  let wish = 0;
  let optional = 0;
  let blocker = 0;
  let open = 0;
  for (const day of days) {
    for (const trip of [day.morning, day.afternoon]) {
      const s = statusOf(trip, displayedUserId);
      if (s === "wish") wish++;
      else if (s === "optional") optional++;
      else if (s === "blocker") blocker++;
      else open++;
    }
  }

  const editing = editingForName != null;

  return (
    <Box
      sx={{
        m: 2,
        mb: 0,
        p: 2,
        borderRadius: 4,
        bgcolor: editing ? "secondary.main" : "primary.main",
        color: editing ? "secondary.contrastText" : "#fff",
      }}
    >
      <Typography fontWeight={700} fontSize={18}>
        {editing
          ? t("weeklyPlan.summary.wishFor", { name: editingForName, count: wish })
          : t("weeklyPlan.summary.wish", { count: wish })}
      </Typography>
      <Typography variant="body2" sx={{ opacity: 0.95 }}>
        {t("weeklyPlan.summary.sub", { optional, blocker, open })}
      </Typography>
    </Box>
  );
}
